import { Checkbox } from "@moe/oss/ui/checkbox";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@moe/oss/ui/form";
import { CharacterService } from "@moe/priv/model/character";
import { BaseData } from "@web/route-services/studio/schema";
import { useFormContext } from "react-hook-form";

interface Props {
  isForcedNSFW?: boolean;
  unavailableOK?: boolean;
}

export function VisibilityFields({ unavailableOK = true, isForcedNSFW = false }: Props) {
  const form = useFormContext<BaseData>();

  return (
    <div className="flex w-full flex-col space-y-5">
      <span className="text-tx-secondary text-sm font-semibold md:text-lg">Visibility</span>
      <div className="flex space-x-6">
        <FormField
          control={form.control}
          name="isPrivate"
          render={({ field }) => (
            <FormItem className="">
              <div className="flex items-center space-x-2">
                <FormControl>
                  <Checkbox checked={field.value} onCheckedChange={field.onChange} disabled={!unavailableOK} />
                </FormControl>
                <FormLabel className="text-tx-primary text-sm font-medium md:text-lg">Private</FormLabel>
                {!unavailableOK && (
                  <p className="text-tx-tertiary text-sm font-medium">
                    {`This character cannot be made private nor deleted since it has more than ${CharacterService.unavailableOKThreshold} messages`}
                  </p>
                )}
              </div>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="isNSFW"
          render={({ field }) => (
            <FormItem className="">
              <div className="flex items-center space-x-2">
                <FormControl>
                  <Checkbox checked={field.value} onCheckedChange={field.onChange} disabled={isForcedNSFW} />
                </FormControl>
                <FormLabel className="text-tx-primary text-sm font-medium md:text-lg">NSFW</FormLabel>
                {isForcedNSFW && (
                  <p className="text-tx-tertiary text-sm font-medium">
                    {`An admin has forced marked this as NSFW. Let @cyan know if this is a mistake.`}
                  </p>
                )}
              </div>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
